﻿import { UserAccountSet } from "../API/Users/UserAccountSet";
import { getUsers } from "../API/Users/Users";
import { IHashData } from "../IHashData";
import { IPage } from "../IPage";
import { MainSite } from "../MainSite";
import { IRegion } from "../Model/Region";
import { UserAccount } from "../Model/UserAccount";

export class EmailUsersPage implements IPage {
    constructor(private mainSite: MainSite) {
    }

    public id: string = 'emailUsers';

    private navBarLink: JQuery;

    public initialize(): void {
    }

    private container: JQuery = null;
    

    private emailsContainer: JQuery = null;

    

    public handleHashChange(hashData: IHashData): boolean {
        if (hashData.Page === this.id) {
            if (!this.container) {
                
                this.renderEmailUsersAfterUsersLoaded();

            }
            return true;
        } else {
            if (this.container) {
                this.container.remove();
                this.container = null;
            }
            return false;
        }
    }

    private userAccountSet: UserAccountSet = null;

    private getUserData(callback: () => any): void {
        getUsers((err: any, data: UserAccountSet) => {
            if (!err) {
                this.userAccountSet = data;
            }
            callback();
        });
        
    }

    private renderEmailUsersAfterUsersLoaded(): void {
        this.getUserData(() => {
            this.renderEmailUsers();
        });
    }

    private renderEmailUsers(): void {

        if (this.container) {
            this.container.remove();
            this.container = null;
        }

        this.container = $('<div class="container"></div>').appendTo('body')

        $('<h1>User Emails</h1>').appendTo(this.container);

        if (this.mainSite.currentUser.Permissions.GlobalAdministrator) {
            $('<p class="midi_manageUsersPage_topParagraph">As a <strong>Global Administrator</strong>, you have access to the email addresses of <strong>all users</strong> within the system.</p>').appendTo(this.container);
            $('<p class="midi_manageUsersPage_topParagraph">Copy the list below into your email address bar to send bulk emails to all users.</p>').appendTo(this.container);
        } else {
            var region: IRegion = this.mainSite.staticDataManager.Schema.RegionSet.Regions[this.mainSite.currentUser.Region];
            $('<p class="midi_manageUsersPage_topParagraph">As a <strong>Regional Administrator</strong> for the <strong>' + region.Label + '</strong> region, you have access to the email addresses of <strong>users within your region</strong>.</p>').appendTo(this.container);
            $('<p class="midi_manageUsersPage_topParagraph">Copy the list below into your email address bar to send bulk emails to all users.</p>').appendTo(this.container);
        }

        this.emailsContainer = $('<textarea rows="8" cols="80" class="midi_EmailUsersPage_box"></textarea>').appendTo(this.container);
        
        var emailString ="";

        for (var userId in this.userAccountSet.UserAccounts) {
            ((user: UserAccount) => {

                if (this.mainSite.currentUser.Permissions.GlobalAdministrator && user.EmailConfirmed && this.mainSite.currentUser.Id != user.Id) {
                    emailString += user.Id + '; ';
                }
                else {
                    if (this.mainSite.currentUser.Region != user.Region || !user.EmailConfirmed || this.mainSite.currentUser.Id == user.Id) {
                        return;
                    }
                    emailString += user.Id + '; ';
                }
                
            })(this.userAccountSet.UserAccounts[userId]);
        }
        if (emailString == "") {
            emailString = "Once users have registered, their email addresses will be displayed here.";
        }
        this.emailsContainer.text(emailString);
    }
}